<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="$t('Please wait')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{
          $t("Product Management")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          $t("Set Basic Product Information")
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('Basic Information')" name="first">
        <div class="form_container">
          <h1>{{ $t("Set Basic Product Information") }}</h1>
          <div class="content_wrap flex-between">
            <div class="form_wrap">
              <div class="block">
                <p><span class="mark">*</span>{{ $t("Product Name") }}：</p>
                <div class="block_wrap flex-rowl">
                  <span>{{ $t("Chinese Name") }}</span>
                  <div class="input_box">
                    <el-input
                      v-model="formData.commodityname"
                      placeholder=""
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.commodityname"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                </div>
                <div class="block_wrap flex-rowl">
                  <span>{{ $t("Product Name") }}</span>
                  <div class="input_box">
                    <el-input
                      v-model="formData.commodityname"
                      :placeholder="$t('Enter Product Name')"
                      v-if="COUNTRY.countryid == 1"
                    ></el-input>
                    <el-input
                      v-model="formData.commodityname_e"
                      :placeholder="$t('Enter Product Name')"
                      v-else-if="COUNTRY.countryid == 8"
                    ></el-input>
                    <el-input
                      v-model="formData.commodityname_m"
                      :placeholder="$t('Enter Product Name')"
                      v-else-if="COUNTRY.countryid == 2"
                    ></el-input>
                    <el-input
                      v-model="formData.commodityname_y"
                      :placeholder="$t('Enter Product Name')"
                      v-else-if="COUNTRY.countryid == 4"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="
                      COUNTRY.countryid == 1
                        ? formData.commodityname
                        : COUNTRY.countryid == 8
                        ? formData.commodityname_e
                        : COUNTRY.countryid == 2
                        ? formData.commodityname_m
                        : formData.commodityname_y
                    "
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                </div>
              </div>
              <div class="detail_content_wrap" v-if="COUNTRY.countryid != 1">
                <div
                  class="detail_content_item flex-rowl"
                  v-for="(item, index) in contents"
                  :key="index"
                >
                  <template v-if="item.conttype == 1">
                    <!-- 图片 -->
                    <div class="content_box">
                      <div class="pic_box">
                        <img :src="item.picurl" alt="" />
                      </div>
                      <div class="download">
                        <a :href="item.picurl" target="_blank"
                          ><el-image
                            style="width: 15px; height: 15px"
                            :src="require('@/assets/images/download_icon.png')"
                          ></el-image
                        ></a>
                      </div>
                    </div>
                    <div class="note_box">
                      <h1>
                        {{ $t("Remarks (translation content or remarks)") }}
                      </h1>
                      <div class="textarea_box">
                        <el-input
                          type="textarea"
                          v-model="item.note"
                          placeholder=""
                          v-if="COUNTRY.countryid == 1"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_e"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 8"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_m"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 2"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_y"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 4"
                        ></el-input>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="item.conttype == 2">
                    <!-- 图片 -->
                    <div class="content_box">
                      <div class="video_box">
                        <video :src="item.videourl" controls></video>
                      </div>
                    </div>

                    <div class="note_box">
                      <h1>
                        {{ $t("Remarks (translation content or remarks)") }}
                      </h1>
                      <div class="textarea_box">
                        <el-input
                          type="textarea"
                          v-model="item.note"
                          placeholder=""
                          v-if="COUNTRY.countryid == 1"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_e"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 8"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_m"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 2"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_y"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 4"
                        ></el-input>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="item.conttype == 3">
                    <!-- 图片 -->
                    <div class="content_box">
                      <div class="txt">
                        <p>{{ item.details }}</p>
                      </div>
                      <div class="copy">
                        <span
                          class="copy_box"
                          :data-clipboard-text="item.details"
                          @click="handleCopyBtn"
                          ><i class="iconfont icon-fuzhi"></i
                        ></span>
                      </div>
                    </div>
                    <div class="note_box">
                      <h1>
                        {{ $t("Remarks (translation content or remarks)") }}
                      </h1>
                      <div class="textarea_box">
                        <el-input
                          type="textarea"
                          v-model="item.note"
                          placeholder=""
                          v-if="COUNTRY.countryid == 1"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_e"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 8"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_m"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 2"
                        ></el-input>
                        <el-input
                          type="textarea"
                          v-model="item.note_y"
                          placeholder=""
                          v-else-if="COUNTRY.countryid == 4"
                        ></el-input>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="tip_wrap">
              <div class="item">
                <h1>SKU ID：</h1>
                <p>{{ detail.sku }}</p>
              </div>
              <div class="item">
                <h1>ISBN ID：</h1>
                <p>{{ detail.ISBN }}</p>
              </div>
              <div class="item">
                <h1>{{ $t("Product Brand") }}：</h1>
                <p>{{ detail.qyename }}</p>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('Product Details')" name="second">
        <div class="form_container">
          <div class="detail_content_wrap detail_content_y_wrap">
            <div
              class="detail_content_item flex-rowl"
              v-for="(item, index) in multilingualContents"
              :key="index"
            >
              <template v-if="item.conttype == 1">
                <!-- 图片 -->
                <div class="content_box">
                  <div class="pic_box">
                    <img :src="item.picurl" alt="" />
                  </div>
                  <div class="download">
                    <a :href="item.picurl" target="_blank"
                      ><el-image
                        style="width: 15px; height: 15px"
                        :src="require('@/assets/images/download_icon.png')"
                      ></el-image
                    ></a>
                  </div>
                </div>
              </template>
              <template v-else-if="item.conttype == 2">
                <!-- 图片 -->
                <div class="content_box">
                  <div class="video_box">
                    <video :src="item.videourl" controls></video>
                  </div>
                </div>
              </template>
              <template v-else-if="item.conttype == 3">
                <!-- 图片 -->
                <div class="content_box">
                  <div class="txt">
                    <p>{{ item.details }}</p>
                  </div>
                  <div class="copy">
                    <span
                      class="copy_box"
                      :data-clipboard-text="item.details"
                      @click="handleCopyBtn"
                      ><i class="iconfont icon-fuzhi"></i
                    ></span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$t('Product attribute label management')"
        name="third"
      >
        <div class="form_container">
          <div class="attr_wrap">
            <div class="attr_list">
              <div class="attr_item flex-rowl">
                <div class="txt">{{ $t("Content") }}</div>
                <div class="input" v-if="COUNTRY.countryid != 1">
                  {{ $t("Enter translation") }}
                </div>
              </div>
            </div>
            <div
              class="attr_list"
              v-for="(item, index) in attrList"
              :key="index"
            >
              <div class="tit">
                {{ item.multilingualAttridstr }}
              </div>
              <div
                class="attr_item flex-rowl"
                v-for="(itemChild, indexChild) in item.attr"
                :key="indexChild"
              >
                <div class="txt">{{ itemChild.attrvalue }}</div>
                <div class="input" v-if="COUNTRY.countryid != 1">
                  <el-input
                    v-model="itemChild.attrvalue"
                    placeholder=""
                    v-if="COUNTRY.countryid == 1"
                  ></el-input>
                  <el-input
                    v-model="itemChild.attrvalue_e"
                    placeholder=""
                    v-else-if="COUNTRY.countryid == 8"
                  ></el-input>
                  <el-input
                    v-model="itemChild.attrvalue_m"
                    placeholder=""
                    v-else-if="COUNTRY.countryid == 2"
                  ></el-input>
                  <el-input
                    v-model="itemChild.attrvalue_y"
                    placeholder=""
                    v-else-if="COUNTRY.countryid == 4"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">{{ $t("Confirm") }}</div>
      <div class="return_txt" @click="handleReturn">←{{ $t("Return") }}</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  editShopDetail,
  encryptstringview,
} from "../../../api/api";
import {
  getLanguageShopDetail,
  getShopCommodityAttr,
  editShopCommodityAttr,
} from "../../../api/shop";
import Clipboard from "clipboard";
import { mapState } from "vuex";
export default {
  name: "cBaseinfo",
  data() {
    return {
      loading: false,
      columnsGoodsType: [
        "普通商品",
        "普通用户积分礼品",
        "商务用户积分礼品",
        "企业积分商品",
      ],
      columnsGoodsSettleType: [
        { value: "零售或批发购买", label: "零售或批发购买" },
        { value: "普通用户积分兑换", label: "普通用户积分兑换" },
        { value: "商户合作用户积分兑换", label: "商户合作用户积分兑换" },
        { value: "企业积分", label: "企业积分" },
      ],

      id: "",
      detail: "",
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        commodityname: "",
        commodityname_e: "",
        commodityname_m: "",
        commodityname_y: "",
        commodityname_t: "",
        commodityname_r: "",
        shortname: "",
        shortname_e: "",
        shortname_m: "",
        shortname_y: "",
        shortname_t: "",
        shortname_r: "",
        comtype: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
        paytype: "",
      },

      activeName: "first",
      contents: [],
      multilingualContents: [], // 多语言内容

      attrList: [],
    };
  },
  computed: {
    ...mapState(["COUNTRY"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getDetail();
        this.getShopCommodityAttr();
      } else {
        this.$router.back();
      }
    },

    handleClick(tab) {
      let { countryid } = this.COUNTRY;
      if (tab.name == "second" && countryid != 1) {
        this.getLanguageShopDetail();
      }
    },

    getDetail() {
      let { countryid } = this.COUNTRY;
      this.loading = true;
      getCommidityDetail({ id: this.id }).then((res) => {
        this.detail = res;
        this.formData.id = res.id ? res.id : "";
        this.formData.commodityname = res.commodityname
          ? res.commodityname
          : "";
        this.formData.commodityname_e = res.commodityname_e
          ? res.commodityname_e
          : "";
        this.formData.commodityname_m = res.commodityname_m
          ? res.commodityname_m
          : "";
        this.formData.commodityname_y = res.commodityname_y
          ? res.commodityname_y
          : "";
        this.formData.commodityname_t = res.commodityname_t
          ? res.commodityname_t
          : "";
        this.formData.commodityname_r = res.commodityname_r
          ? res.commodityname_r
          : "";
        this.formData.shortname = res.shortname ? res.shortname : "";
        this.formData.shortname_e = res.shortname_e ? res.shortname_e : "";
        this.formData.shortname_m = res.shortname_m ? res.shortname_m : "";
        this.formData.shortname_y = res.shortname_y ? res.shortname_y : "";
        this.formData.shortname_t = res.shortname_t ? res.shortname_t : "";
        this.formData.shortname_r = res.shortname_r ? res.shortname_r : "";
        this.formData.comtype = res.comtype ? res.comtype : "";
        this.formData.labelid = res.labelid ? res.labelid : "";
        this.formData.labelid2 = res.labelid2 ? res.labelid2 : "";
        this.formData.labelid3 = res.labelid3 ? res.labelid3 : "";
        this.formData.paytype = res.paytype ? res.paytype : "";

        this.contents = res.details;
        this.contents.sort((a, b) => a.sortno - b.sortno);

        if (countryid == 1) {
          this.multilingualContents = res.details;
          this.multilingualContents.sort((a, b) => a.sortno - b.sortno);
        }

        this.loading = false;
      });
    },

    // 除中文外其他国家内容
    getLanguageShopDetail() {
      this.loading = true;
      let { countryid } = this.COUNTRY;
      let lan =
        countryid == 8 ? "e" : countryid == 2 ? "m" : countryid == 4 ? "y" : "";
      let params = {
        lan: lan,
        id: this.id,
      };
      getLanguageShopDetail(params).then((res) => {
        this.multilingualContents = res.details;
        this.multilingualContents.sort((a, b) => a.sortno - b.sortno);
        this.loading = false;
      });
    },

    // 获取商品属性
    getShopCommodityAttr() {
      let { countryid } = this.COUNTRY;
      let params = {
        cmid: this.id,
        pageindex: 1,
        pagesize: 40,
      };
      getShopCommodityAttr(params).then((res) => {
        let newArr = res.list.reduce((result, item) => {
          // 查找是否已存在相同 attridstr 的对象
          let existing = result.find((obj) => obj.attrid === item.attrid);

          if (existing) {
            // 如果存在，则将当前项添加到 attr 数组中
            existing.attr.push(item);
          } else {
            // 如果不存在，则创建新的对象并将当前项添加到 attr 数组中
            result.push({
              attridstr: item.attridstr,
              multilingualAttridstr:
                countryid == 1
                  ? item.attridstr
                  : countryid == 8
                  ? item.attridstr_e
                  : countryid == 2
                  ? item.attridstr_m
                  : countryid == 4
                  ? item.attridstr_y
                  : "",
              attrid: item.attrid,
              attr: [item],
            });
          }

          return result;
        }, []);
        console.log(newArr);

        this.attrList = newArr;
      });
    },

    submitItem(item) {
      editShopDetail(item).then((res) => {
        console.log(res, "=========");
      });
    },
    // 提交数据
    async submitData() {
      let { contents } = this;
      this.counter = 0; // 重置计数器
      for (let i = 0; i < contents.length; i++) {
        const item = contents[i];
        try {
          // 在此处进行实际的提交操作，可以使用axios或其他HTTP库发送数据到服务器
          await this.submitItem(item);
          this.counter++; // 提交成功，计数器加1
          if (this.counter === contents.length) {
            this.loading = false;
            this.$message.success(this.$t("Modification successful"));
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$message.success("提交成功");
            // }, 200);
            // setTimeout(() => {
            //   history.back();
            // }, 1000);
          }
        } catch (error) {
          console.log(error, "=======");
          this.loading = false;
        }
      }
    },

    query() {
      let { formData, activeName, attrList } = this;
      let { countryid } = this.COUNTRY;
      if (activeName == "third") {
        let arr = attrList.flatMap((group) => group.attr);
        let newArr = arr.map(
          ({
            id,
            cmid,
            attrid,
            attrvalue,
            attrvalue_e,
            attrvalue_y,
            attrvalue_m,
            attrvalue_t,
            attrvalue_r,
            numtype,
            num,
            pic,
            isheavy,
            isuse,
            aipic1,
            aipic1_site,
            aipic2,
            aipic2_site,
            aipic3,
            aipic3_site,
          }) => ({
            id,
            cmid,
            attrid,
            attrvalue,
            attrvalue_e,
            attrvalue_y,
            attrvalue_m,
            attrvalue_t,
            attrvalue_r,
            numtype,
            num,
            pic,
            isheavy,
            isuse,
            aipic1,
            aipic1_site,
            aipic2,
            aipic2_site,
            aipic3,
            aipic3_site,
          })
        );
        this.submitAttrData(newArr);
      } else {
        let multilingualName = countryid == 1 ? formData.commodityname : (countryid == 8? formData.commodityname_e : (countryid == 2? formData.commodityname_m : (countryid == 4? formData.commodityname_y : "")))
        if(multilingualName == '') {
          this.$message.warning(this.$t("Enter Product Name"));
          return;
        }

        this.loading = true;
        editCommidity(formData).then((res) => {
          if (res.result) {
            this.submitData();
            // this.loading = false;
            // this.$message.success(
            //   res.message == "修改成功" ? "修改成功" : res.message
            // );
            // setTimeout(() => {
            //   message.close();
            //   history.back();
            // }, 1500);
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$router.back();
            // }, 500);
          } else {
            this.loading = false;
            this.$message.error(this.$t("Server Error"));
          }
        });
      }
    },

    async submitAttrData(contents) {
      console.log(contents, "===-=");

      this.counter = 0; // 重置计数器
      for (let i = 0; i < contents.length; i++) {
        const item = contents[i];
        try {
          // 在此处进行实际的提交操作，可以使用axios或其他HTTP库发送数据到服务器
          await this.submitAttrItem(item);
          this.counter++; // 提交成功，计数器加1
          if (this.counter === contents.length) {
            this.loading = false;
            this.$message.success(this.$t("Modification successful"));
          }
        } catch (error) {
          console.log(error, "=======");
          this.loading = false;
        }
      }
    },

    // 商品属性修改
    submitAttrItem(item) {
      editShopCommodityAttr(item).then((res) => {
        console.log(res, "=--=");
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "home" });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
        width: 48%;
        .block_wrap {
          margin-bottom: 20px;
          position: relative;
          span {
            font-size: 12px;
            margin-right: 10px;
            width: 100px;
            flex-shrink: 0;
          }
          .input_box {
            margin-bottom: 0;
            flex: 1;
            /deep/ .el-input {
              &.is-disabled {
                .el-input__inner {
                  background-color: #fff;
                  color: #4f4e4e;
                }
              }
            }
          }
          .copy_box {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: -35px;
            cursor: pointer;
            width: auto;
            margin-right: 0;
            .icon-fuzhi {
              font-size: 20px;
              color: #7d7d7d;
            }
          }
        }
        .radio_box {
          .el-radio {
            margin-bottom: 10px;
          }
        }
        .shop_label_wrap {
          .radio_box {
            margin: 30px 10px;
            p {
              font-size: 14px;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
    .detail_content_wrap {
      margin-top: 70px;
      .detail_content_item {
        width: 100%;
        align-items: flex-start;
        margin-bottom: 30px;
        .content_box {
          width: 48%;
          margin-right: 2%;
          .download,
          .copy {
            margin-top: 8px;
            cursor: pointer;
          }
        }
        .pic_box {
          img {
            width: 100%;
          }
        }
        .video_box {
          video {
            width: 100%;
          }
        }
        .note_box {
          width: 50%;
          h1 {
            font-size: 14px;
            margin-bottom: 10px;
          }
        }
      }
      &.detail_content_y_wrap {
        margin-top: 0;
      }
    }
    .attr_wrap {
      width: 50%;
      .attr_list {
        margin-bottom: 40px;
        &:first-child {
          margin-bottom: 10px;
          .attr_item {
            font-size: 18px;
          }
        }
        .tit {
          margin-bottom: 10px;
          font-size: 16px;
        }
        .attr_item {
          height: 50px;
          font-size: 14px;
          .txt {
            width: 20%;
          }
          .input {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>